module.exports = __webpack_public_path__ + "media/greaves2.a5146f91.webm";